import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import styled from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';
import StoryCompoment from '@/components/stories';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/brand-story';

const Stories: React.FC<any> = ({ SEO }) => {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('brandstory');

    return (
        <PageLayout className={`${styled.stories}`}>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <StoryCompoment />
        </PageLayout>
    );
};

export default Stories;

// 以下两个方法不可删除，否则会重复触发 _app.js 中 getInitialProps 中的请求
export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = ['jp'];
    if (!locale || !whiteLocaleList.includes(locale)) {
        return { notFound: true };
    }
    return {
        props: {},
    };
}
